import React, { useEffect, useState } from 'react';
import Modal from '@app/react-common/components/modal/Modal';
import Button from '@app/react-common/components/button/Button';
import Input from '@app/react-common/components/input/Input';

interface CheckoutModalProps {
  mode: 'create' | 'rename' | 'delete' | 'duplicate' | 'settings';
  isOpen;
  onClose;
  onCreateSuccess?: (checkout: CheckoutFormData) => Promise<void>;
  onRenameSuccess?: (checkout: CheckoutFormData) => Promise<void>;
  onDeleteSuccess?: () => Promise<void>;
  checkoutName?: string;
  checkoutDescription?: string;
  onDuplicateSuccess?: (checkout: CheckoutFormData) => Promise<void>;
}

export interface CheckoutFormData {
  name: string;
  description: string;
}

export const CheckoutModal: React.FC<CheckoutModalProps> = (props: CheckoutModalProps) => {
  const { getTitle, getButton } = useNamingUtils();
  const [showValidation, setShowValidation] = useState(false);

  const [formData, setFormData] = useState<CheckoutFormData>({
    name: props?.checkoutName || '',
    description: props?.checkoutDescription || '',
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  useEffect(() => {
    setFormData({
      name: props.checkoutName,
      description: props.checkoutDescription,
    });
  }, [props.checkoutName, props.checkoutDescription]);

  const buttonClick = async () => {
    if (props.mode == 'create') props.onCreateSuccess(formData);
    else if (props.mode == 'rename') props.onRenameSuccess(formData);
    else if (props.mode == 'delete') props.onDeleteSuccess();
    else if (props.mode == 'duplicate') props.onDuplicateSuccess(formData);
  };

  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose}>
      <div className="checkout-modal">
        {props.mode != 'settings' && (
          <h2 className="checkout-modal__title">{getTitle(props.mode, props.checkoutName)}</h2>
        )}
        {(props.mode == 'create' || props.mode == 'rename' || props.mode == 'duplicate') && (
          <>
            <Input
              wrapperDivClassName="checkout-modal__checkout-input"
              required={true}
              showValidation={showValidation}
              type="text"
              placeholder="Version name"
              label="Name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
            />
            <Input
              wrapperDivClassName="checkout-modal__checkout-input"
              type="text"
              placeholder="Version Description"
              label="Description"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
            />
          </>
        )}

        <div className="checkout-modal__actions">
          <Button
            onClick={props.onClose}
            text={'Cancel'}
            size={'medium'}
            variant={'secondary'}
            className="checkout-modal__actions__cancel"
          />
          <Button
            onClick={async () => {
              if (props.mode == 'delete' || props.mode == 'settings' || formData?.name?.length > 0) await buttonClick();
              else setShowValidation(true);
            }}
            text={getButton(props.mode)}
            size={'medium'}
            variant={props.mode == 'delete' ? 'danger' : 'primary'}
          />
        </div>
      </div>
    </Modal>
  );
};

function useNamingUtils() {
  const getTitle = (mode, checkoutName): string => {
    if (mode === 'create') {
      return 'New checkout';
    } else if (mode === 'rename') {
      return 'Rename checkout';
    } else if (mode === 'delete') {
      return 'Are you sure you want to delete this version?';
    } else if (mode === 'duplicate') {
      return 'Duplicate checkout';
    } else if (mode === 'settings') {
      return 'Settings';
    }
  };

  const getButton = (mode): string => {
    if (mode === 'create') {
      return 'Create checkout';
    } else if (mode === 'rename') {
      return 'Save';
    } else if (mode === 'delete') {
      return 'Delete';
    } else if (mode === 'duplicate') {
      return 'Duplicate';
    } else if (mode === 'settings') {
      return 'Save';
    }
  };
  return { getTitle, getButton };
}
